import { RcsCampaignFormValues, TenDlcCampaignFormValues } from './types';
import {
  BrandSelectionFormValues,
  CarrierTermsFormValues,
  ComplianceFormValues,
  LaunchDetailsFormValues,
  RcsCampaignDetailsFormValues,
} from '../../components';
import {
  CampaignDetailsFormValues,
  CarrierSelectionFormValues,
} from '../../types';

export const FallbackSteps = ['Brand Selection'];
export const TenDlcSteps = [
  'Use Case Selection',
  'Carrier Terms Preview',
  'Campaign Details',
];
export const RcsSteps = [
  'Brand Selection',
  'Campaign Details',
  'Carrier Terms',
  'Launch Details',
  'Compliance',
];

export const DefaultCarrierSelectionFormValues: CarrierSelectionFormValues = {
  mnoIds: [],
};

export const DefaultCampaignDetailsFormValues: CampaignDetailsFormValues = {
  description: '',
  messageFlow: '',
  termsAndConditionsLink: '',
  privacyPolicyLink: '',
  supportingDocument: [],
  sampleMessages: [{ message: '' }],
  sampleMultimedia: [],
  subscriberOptin: undefined,
  optinKeywords: [],
  optinMessage: '',
  subscriberOptout: undefined,
  optoutKeywords: [],
  optoutMessage: '',
  subscriberHelp: undefined,
  helpKeywords: [],
  helpMessage: '',
  numberPool: undefined,
  directLending: undefined,
  embeddedLink: undefined,
  embeddedLinkSample: '',
  embeddedPhone: undefined,
  ageGated: undefined,
  termsAndConditions: undefined,
  upstreamCnpUid: '',
  resellerUid: '',
  referenceId: '',
};

export const DefaultTenDlcCampaignFormValues: TenDlcCampaignFormValues = {
  carrierSelectionFormValues: DefaultCarrierSelectionFormValues,
  campaignDetailsFormValues: DefaultCampaignDetailsFormValues,
};

export const DefaultBrandSelectionFormValues: BrandSelectionFormValues = {
  brandUid: '',
  brandName: '',
  channelId: '',
  tenDlcUseCase: undefined,
  tenDlcSubUseCases: [],
  billingCategory: '',
  hostingRegion: '',
  rcsUseCase: '',
};

export const DefaultRcsCampaignDetailsFormValues: RcsCampaignDetailsFormValues =
  {
    displayName: '',
    color: navigator.webdriver ? '#FF0000' : '',
    shortDescription: '',
    termsAndConditionsLink: '',
    privacyPolicyLink: '',
    phonePairs: [
      {
        phone: '',
        label: '',
        timestamp: 0,
      },
    ],
    emailPairs: [
      {
        email: '',
        label: '',
        timestamp: 0,
      },
    ],
    websitePairs: [
      {
        website: '',
        label: '',
        timestamp: 0,
      },
    ],
    campaignLogo: '',
    campaignBanner: '',
  };

export const DefaultCarrierTermsFormValues: CarrierTermsFormValues = {
  mnoIds: [],
};

export const DefaultLaunchDetailsFormValues: LaunchDetailsFormValues = {
  actionTriggerMessages: '',
  messageTypes: '',
  optinFlow: '',
  optoutFlow: '',
  screenshotUrl: '',
  videoUrl: '',
  technicalContactName: '',
  technicalContactJobTitle: '',
  technicalContactEmail: '',
};

export const DefaultComplianceFormValues: ComplianceFormValues = {
  samples: [{ message: '' }],
  subscriberOptin: undefined,
  optinKeywords: [],
  optinMessage: '',
  subscriberOptout: undefined,
  optoutKeywords: [],
  optoutMessage: '',
  subscriberHelp: undefined,
  helpKeywords: [],
  helpMessage: '',
  directLending: undefined,
  embeddedLink: undefined,
  embeddedPhone: undefined,
  ageGated: undefined,
  cnpUid: '',
  resellerUid: '',
};

export const DefaultRcsCampaignFormValues: RcsCampaignFormValues = {
  carrierTermsFormValues: DefaultCarrierTermsFormValues,
  launchDetailsFormValues: DefaultLaunchDetailsFormValues,
  complianceFormValues: DefaultComplianceFormValues,
  rcsCampaignDetailsFormValues: DefaultRcsCampaignDetailsFormValues,
};
